// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      height: '100%',
      width: 500,
      overflowX: 'hidden',
    },
    resetPdTop: {
      paddingTop: 0,
    },
    resetPdBottom: {
      paddingBottom: 0,
    },
    form: {
      margin: theme.spacing(0),
      padding: theme.spacing(0),
    },
    title: {
      color: theme.palette.primary.main,
    },
    message: {
      marginTop: theme.spacing(2),
      textAlign: 'center',
    },
    infos: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
    subTtitle: {
      color: '#666',
    },
    registrationDate: {
      color: '#777',
      fontSize: '0.9em',
      paddingLeft: theme.spacing(2),
    },
    cardAddress: {
      background: theme.palette.colors.gray5,
      borderRadius: 5,
      padding: theme.spacing(1),
    },
    cardAddressImage: {
      background: 'rgba(239, 239, 239, 0.5)',
      mixBlendMode: 'multiply',
      borderRadius: '0px 5px 5px 0px',
      margin: -theme.spacing(1),

      '& img': {
        objectFit: 'contain',
        height: 100,
        padding: theme.spacing(2),
      },
    },
    margins: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    line: {
      width: theme.spacing(3),
      height: 2,
      borderRadius: 4,
      marginRight: theme.spacing(2),
    },
    lineEven: {
      background: theme.palette.colors.lightBlue,
    },
    lineOdd: {
      background: theme.palette.colors.yellowLight,
    },
    lineContainer: {
      padding: theme.spacing(1),
    },
    even: {
      background: theme.palette.colors.gray5,
    },
    label: {
      fontSize: 18,
      fontWeight: 500,
      marginBottom: theme.spacing(1),
    },
    chartContainer: {
      minHeight: 200,
      background: theme.palette.colors.gray5,
      padding: theme.spacing(1),
      paddingTop: 0,
    },
    noContent: {
      height: 200,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    legend: {
      marginLeft: 12,
      marginBottom: theme.spacing(1),
    },
    legendText: {
      fontSize: '0.85rem',
      color: theme.palette.colors.gray1,
    },
    square: {
      width: 25,
      height: 15,
      borderRadius: 4,
      marginRight: 4,
    },
    squareGreen: {
      background: theme.palette.colors.greenDegrade,
    },
    squareDarkBlue: {
      background: theme.palette.colors.darkBlue,
    },
  }),
);

export default useStyles;
